const PolicyCancellationReasonValues = {
    NO_CAR: 'NO_CAR',
    NON_PAYMENT: 'NON_PAYMENT',
    LICENSE_SUSPENSION: 'LICENSE_SUSPENSION',
    MATERIAL_MISREPRESENTATION: 'MATERIAL_MISREPRESENTATION',
    DRIVING_WITHOUT_INSURANCE: 'DRIVING_WITHOUT_INSURANCE',
    NON_DISCLOSURE: 'NON_DISCLOSURE',
    OTHER: 'OTHER',
};

export default PolicyCancellationReasonValues;
